/* eslint-disable prettier/prettier */
import { ProductFragment } from '@core-mkt/shared/craft/product-entry-fragment';
import * as gql from 'fake-tag';

export const PricingTableFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  pricingTable: gql`
    fragment pricingTableQuery on pricingTable_Entry {
      guaranteeText
      bundles: bundles2 {
        ... on bundles2Block_Entry {
          bottomContent {
            html
          }
          ctaLabel
          ctaLinkNewTab
          ctaLinkNofollow
          ctaLinkOverride
          ctaStyle
          principalContent {
            html
          }
          product {
            ...ProductEntry
          }
          topContent
          topContentStyles
        }
      }
      bundleTitleOne
      bundleTitleTwo
      bundleTitleThree
      pricingTableItems {
        ... on pricingTableItemsBlock_Entry {
          principalContent {
            html
          }
          productOne
          productTwo
          productThree
          labelHeader
          aceMode
        }
      }
      lineBreak_PricingTableItems
      lineBreak_bundlesMainContent
      lineBreak_styles
      styles
      typeHandle
    }
    ${ProductFragment.product}
  `,
};
